import { Date } from 'core-js'
import moment from 'moment'
// import parseTime, formatTime and set to filter
export { parseTime } from '@/utils'

/**
 * Show plural label if time is plural number
 * @param {number} time
 * @param {string} label
 * @return {string}
 */
function pluralize(time, label) {
  if (time === 1) {
    return time + label
  }
  return time + label + 's'
}

/**
 * @param {number} time
 */
export function timeAgo(time) {
  var fitstTime = new Date(new Date(time).getTime())
  var nowDate = new Date(new Date().getTime())
  var currentTime
  if (fitstTime < nowDate) {
    currentTime = nowDate - fitstTime
  } else {
    currentTime = fitstTime - nowDate
  }

  var days = Math.floor(currentTime / (24 * 3600 * 1000)) // 计算出相差天数
  var leave1 = currentTime % (24 * 3600 * 1000) // 计算天数后剩余的毫秒数
  var hours = Math.floor(leave1 / (3600 * 1000)) // 计算相差分钟数
  var leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
  var minutes = Math.floor(leave2 / (60 * 1000)) // 计算相差秒数
  var leave3 = leave2 % (60 * 1000) // 计算分钟数后剩余的毫秒数
  var seconds = Math.round(leave3 / 1000)
  if (days > 7) {
    return `超过一周`
  } else if (days > 0) {
    return `${days}天${hours}小时`
  } else if (hours > 0) {
    return `${hours}小时${minutes}分钟`
  } else {
    return `${minutes}分钟`
  }
}
// Due to到期时间
export function Dueto(time) {
  if (!time) {
    return ''
  }
  var fitstTime = new Date(new Date(time).getTime())
  var nowDate = new Date(new Date().getTime())
  var currentTime = fitstTime - nowDate
  if (currentTime < 0) {
    return ''
  }
  // if(fitstTime<nowDate){
  // }else{
  //  var currentTime = fitstTime - nowDate
  // }

  var days = Math.floor(currentTime / (24 * 3600 * 1000)) // 计算出相差天数
  var leave1 = currentTime % (24 * 3600 * 1000) // 计算天数后剩余的毫秒数
  var hours = Math.floor(leave1 / (3600 * 1000)) // 计算相差分钟数
  var leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
  var minutes = Math.floor(leave2 / (60 * 1000)) // 计算相差秒数
  var leave3 = leave2 % (60 * 1000) // 计算分钟数后剩余的毫秒数
  var seconds = Math.round(leave3 / 1000)
  return `(${days}天后到期)`
  // if (days > 7) {
  //   return `超过一周`
  // } else if (days > 0) {
  //   return `${days}天${hours}小时`
  // } else if (hours > 0) {
  //   return `${hours}小时${minutes}分钟`
  // } else {
  //   return `${minutes}分钟`
  // }
}
/**
 *
 * @param {strign} time
 * @param {*} 时间格式化
 */
export function formatTime(time) {
  var timestamp = new Date(time) / 1000
  var day = ''
  var month = ''
  var d = new Date(timestamp * 1000)
  day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
  month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1)
  var date = (d.getFullYear() + '-' + month + '-' + day)
  return date
}

/**
 * Number formatting
 * like 10000 => 10k
 * @param {number} num
 * @param {number} digits
 */
export function numberFormatter(num, digits) {
  const si = [
    { value: 1E18, symbol: 'E' },
    { value: 1E15, symbol: 'P' },
    { value: 1E12, symbol: 'T' },
    { value: 1E9, symbol: 'G' },
    { value: 1E6, symbol: 'M' },
    { value: 1E3, symbol: 'k' }
  ]
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
    }
  }
  return num.toString()
}

/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter(num) {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

/**
 * Upper case first char
 * @param {String} string
 */
export function face(e) {
  const options = [{ code: 'SUCCESS', info: '待比对照片与参考照片比对结果是同一个人' },
    { code: 'PASS_LIVING_NOT_THE_SAME', info: '待比对照片与参考照片比对结果不是同一个人' },
    { code: 'NO_ID_CARD_NUMBER', info: '无此身份证号' },
    { code: 'ID_NUMBER_NAME_NOT_MATCH', info: '身份证号，姓名不匹配' },
    { code: 'NO_FACE_FOUND', info: '参考照片中找不到人脸' },
    { code: 'NO_ID_PHOTO', info: '无法获取参考照片' },
    { code: 'PHOTO_FORMAT_ERROR', info: '参考照片格式错误' },
    { code: 'DATA_SOURCE_ERROR', info: '其他参考照片错误' },
    { code: 'FAIL_LIVING_FACE_ATTACK', info: '未经过活体判断，可能的原因：是假脸攻击' },
    { code: 'VIDEO_LACK_FRAMES', info: '获取到的活体数据故障，请换一台手机重试' },
    { code: 'FAIL_EYES_CLOSE_DETECTION', info: '未通过闭眼检测，活体失败' },
    { code: 'BIZ_TOKEN_DENIED', info: '传入的 biz_token 不符合要求' },
    { code: 'AUTHENTICATION_FAIL', info: ' 鉴权失败' },
    { code: 'MOBILE_PHONE_NOT_SUPPORT', info: '手机在不支持列表里' },
    { code: 'SDK_TOO_OLD', info: 'SDK版本过旧，已经不被支持' },
    { code: 'MOBILE_PHONE_NO_AUTHORITY', info: '没有权限（运动传感器、存储、相机）' },
    { code: 'USER_CANCELLATION', info: '用户活体失败，可能原因：用户取消了' },
    { code: 'USER_TIMEOUT', info: '用户活体失败，可能原因：验证过程超时' },
    { code: 'VERIFICATION_FAILURE', info: '用户活体失败，可能原因：验证失败' },
    { code: 'UNDETECTED_FACE ', 用info: '户活体失败，可能原因：未检测到人脸' },
    { code: 'ACTION_ERROR', info: '用户活体失败，可能原因：用户动作错误；' },
    { code: 'API_KEY_BE_DISCONTINUED', info: 'api_key被停用' },
    { code: 'IP_NOT_ALLOWED', info: '不允许访问的IP' },
    { code: 'NON_ENTERPRISE_CERTIFICATION', info: '客户未进行企业认证' },
    { code: 'BALANCE_NOT_ENOUGH', info: '余额不足' },
    { code: 'MORE_RETRY_TIMES', info: '获取服务器配置时超过重试次数' },
    { code: 'ACCOUNT_DISCONTINUED', info: '用户帐号已停用' },
    { code: 'EXPIRED_SIGN', info: '签名过期' },
    { code: 'INVALID_SIGN', info: '无效的签名' },
    { code: 'REPLAY_ATTACK', info: '重放攻击，单次有效的签名被多次使用' },
    { code: 'USER_CANCEL', info: '用户取消' },
    { code: 'NO_CAMERA_PERMISSION', info: '没有打开相机的权限，请开启权限后重试' },
    { code: 'ILLEGAL_PARAMETER', info: '传入参数不合法' },
    { code: 'DEVICE_NOT_SUPPORT', info: '无法启动相机，请确认摄像头功能完好' },
    { code: 'INVALID_BUNDLE_ID', info: '信息验证失败，请重启程序或设备后重试' },
    { code: 'NETWORK_ERROR', info: '连不上互联网，请连接上互联网后重试' },
    { code: 'FACE_INIT_FAIL', info: '无法启动人脸识别，请稍后重试' },
    { code: 'LIVENESS_DETECT_FAILED', info: '活体检测不通过' },
    { code: 'NO_SENSOR_PERMISSION', info: '无法读取运动数据的权限，请开启权限后重试' },
    { code: 'INIT_FAILED', info: '初始化失败' },
    { code: 'LIVING_NOT_START', info: '活体验证没有开始' },
    { code: 'LIVING_IN_PROGRESS', info: '正在进行验证' },
    { code: 'LIVING_OVERTIME', info: '操作超时，由于用户在长时间没有进行操作' }]
  var index = options.findIndex(item => item.code == e)
  if (index != -1) {
    return options[index].info
  }
  return
}
export function formatTimeDaily(e) {
  if (!e) {
    return
  }
  return moment(e).format('YYYY-MM-DD')
}
//  秒数转化为时分秒
export function formatSeconds(value) {
  //  秒
  let second = parseInt(value)
  //  分
  let minute = 0
  //  小时
  let hour = 0
  //  天
  //  let day = 0
  //  如果秒数大于60，将秒数转换成整数
  if (second > 60) {
    //  获取分钟，除以60取整数，得到整数分钟
    minute = parseInt(second / 60)
    //  获取秒数，秒数取佘，得到整数秒数
    second = parseInt(second % 60)
    //  如果分钟大于60，将分钟转换成小时
    if (minute > 60) {
      //  获取小时，获取分钟除以60，得到整数小时
      hour = parseInt(minute / 60)
      //  获取小时后取佘的分，获取分钟除以60取佘的分
      minute = parseInt(minute % 60)
      //  如果小时大于24，将小时转换成天
      //  if (hour > 23) {
      //    //  获取天数，获取小时除以24，得到整天数
      //    day = parseInt(hour / 24)
      //    //  获取天数后取余的小时，获取小时除以24取余的小时
      //    hour = parseInt(hour % 24)
      //  }
    }
  }

  let result = '' + parseInt(second) + '秒'
  if (minute > 0) {
    result = '' + parseInt(minute) + '分' + result
  }
  if (hour > 0) {
    result = '' + parseInt(hour) + '小时' + result
  }
  return result
}